import Keycloak from 'keycloak-js';

import { KEYCLOAK_STORAGE_KEY } from './';

const parsedAppConfig = JSON.parse(process.env.APP_CONFIG);

const keycloak = Keycloak(parsedAppConfig.REACT_APP_KEYCLOAK);

const getTokenStorage = () => JSON.parse(localStorage.getItem(KEYCLOAK_STORAGE_KEY));

const setTokenStorage = () => {
    localStorage.setItem(
        KEYCLOAK_STORAGE_KEY,
        JSON.stringify({
            token: keycloak.token,
            idToken: keycloak.idToken,
            refreshToken: keycloak.refreshToken
        })
    );
};

const setTokenStorageForMobileRoute = (token, idToken, refreshToken) => {
    localStorage.setItem(
        KEYCLOAK_STORAGE_KEY,
        JSON.stringify({
            token,
            idToken,
            refreshToken
        })
    );
};

const removeTokenStorage = () => {
    localStorage.removeItem(KEYCLOAK_STORAGE_KEY);
};

/**
 * @todo very shamefull mock shame , Shame, SHAME!!!! we need to resolve this in future
 * test doesnt uses keycloak adapter to auth because it cannot do a redirect to login keycloak page
 * so keycloak object during test is not initialized at all but api.js uses it to refresh token
 */
const mockedMethods =
    process.env.NODE_ENV === 'test'
        ? {
              logout: () => {},
              updateToken: () => ({
                  success: callback => {
                      callback();
                      return { error: () => {} };
                  }
              })
          }
        : {};

export default { ...keycloak, getTokenStorage, removeTokenStorage, setTokenStorage, setTokenStorageForMobileRoute, ...mockedMethods };
